import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PosmDemandComponent } from './posm-demand.component';
import { DemandFormComponent } from './demand-form/demand-form.component';
import { DemandListComponent } from './demand-list/demand-list.component';

const routes: Routes = [
  //{ path: '', redirectTo: '/test/menu', pathMatch: 'full' },
  {
    path: '',
    component: PosmDemandComponent,
    children: [
        {
          path: 'add',
          component: DemandFormComponent
        },
        {
          path: 'list',
          component: DemandListComponent
        }

       
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class PosmDemandRoutingModule { }
